// extracted by mini-css-extract-plugin
export default {"screen":"styles_screen__AHmt8"};